// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Input style */
.input-field-autocomplete-search input{
    background: transparent;
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
    margin-top: var(--space);
    margin-bottom: var(--space);
    margin-left: var(--space-and-half);
    margin-right: var(--space);
}

/* label style */

.input-field-autocomplete-search label { 
    position: absolute; 
    font-weight: var(--font-medium);
    font-family: var(--secondary-font);
    line-height: var(--space);
    letter-spacing: 0.004em;
    color: var(--primary-dark-color);
    /* text-transform: capitalize; */
    padding: 0 var(--space-half);
}

.input-field-autocomplete-search label.MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(0px, -22px);
}

.input-field-autocomplete-search div{
    border-radius: 2px;
    padding: 0px !important;
}

.input-field-autocomplete-search .MuiOutlinedInput-input{
    padding: 0px;   
}

/* .input-field-autocomplete-search .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{
    border: var(--input-field-border);
} */

.input-field-autocomplete-search .MuiOutlinedInput-notchedOutline {
    border-style: none;
}

.input-field-autocomplete-search .MuiInputBase-input{
    max-height: calc(var(--space-x3) + var(--space-half));
}

.input-field-autocomplete-search .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input{
    padding: 0px;
}

.input-field-autocomplete-search .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child{
    padding: 0px;
}

.input-field-autocomplete-search.MuiFormControl-marginNormal{
    margin: 0px;
}

.input-field-autocomplete-search.error .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline { 
    border: var(--input-field-border-error);
}

.input-field-auto-search {
    position: relative;
    margin: var(--space-x3) 0;
}
.input-field-autocomplete-search::placeholder {
    color: var(--disabled-color);
}

.input-field-autocomplete-search__message {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: var(--space-half-quarter);
    line-height: var(--space);
    color: var(--primary-dark-color);
    width: fit-content;
    margin-left: var(--space-x2);
    margin-top: 4px;
    margin-left: var(--space);
    position: absolute;
    text-align: left;
}
.input-field-autocomplete-search__message.error {
    color: var(--error-color);
}

.input-field-autocomplete-with-search__list__icon__icon-ball {
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.input-field-autocomplete-with-search__list__icon {
    width: 18px;
    height: 18px;
}

.input-field-autocomplete-with-search__list__icon__icon-ball .icon-ball {
    color: var( --white-color );
    font-size: 12px;
    border-radius: 50%;
    padding: 4px;    
}

.input-field-autocomplete-with-search__list__icon img {
    width: 18px;
    border-radius: 50%;
    height: 18px;
        
}

.input-field-autocomplete-with-search__list__icon-team {
    width: 38px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.input-field-autocomplete-with-search__list__icon-team__icon-ball {
    display: flex;
    align-items: center;
    justify-content: center;
}

.input-field-autocomplete-with-search__list__icon-team__icon-ball .icon-ball {
    color: var( --white-color );
    font-size: 30px;
    border-radius: 50%;
    padding: 4px;    
}

.input-field-autocomplete-with-search__list__icon-team img {
    width: 38px;
    height: 38px;
    border-radius: 50%;    
}

.input-field-autocomplete-with-search__list.MuiListItem-root,
.input-field-autocomplete-with-search__list-selected.MuiListItem-root  {
    gap: 10px;
}

.input-field-autocomplete-with-search__list__country-logo__label {
    font-family: var(--secondary-font);
    font-size: var(--space);
    position: absolute;
    bottom: 52px;
}

.input-field-autocomplete-with-search__list__country-logo .hubicon-clear_option {
    font-size: 12px;
    cursor: pointer;
}

.input-field-autocomplete-with-search__list-selected__location {
    display: flex;
    align-items: center;
    text-transform: lowercase;
}

.input-field-autocomplete-with-search__list-selected__location span{
    text-transform: none;
}

.input-field-autocomplete-with-search__list-selected__location p::first-letter {
    text-transform: uppercase;
}

.input-field-autocomplete-with-search__list-selected .icon-location{
    margin-right: 4px;
    font-size: 20px;
}

.input-field-auto-search .MuiAutocomplete-paper {
    /* position: fixed; */
    width: inherit;
}


`, "",{"version":3,"sources":["webpack://./src/shared/components/input-field-autocomplete-with-search/InputFieldAutocompleteWithSearchComponent.styles.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,uBAAuB;IACvB,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,kCAAkC;IAClC,yBAAyB;IACzB,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":["/*Input style */\n.input-field-autocomplete-search input{\n    background: transparent;\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    margin-left: var(--space-and-half);\n    margin-right: var(--space);\n}\n\n/* label style */\n\n.input-field-autocomplete-search label { \n    position: absolute; \n    font-weight: var(--font-medium);\n    font-family: var(--secondary-font);\n    line-height: var(--space);\n    letter-spacing: 0.004em;\n    color: var(--primary-dark-color);\n    /* text-transform: capitalize; */\n    padding: 0 var(--space-half);\n}\n\n.input-field-autocomplete-search label.MuiInputLabel-outlined.MuiInputLabel-shrink {\n    transform: translate(0px, -22px);\n}\n\n.input-field-autocomplete-search div{\n    border-radius: 2px;\n    padding: 0px !important;\n}\n\n.input-field-autocomplete-search .MuiOutlinedInput-input{\n    padding: 0px;   \n}\n\n/* .input-field-autocomplete-search .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{\n    border: var(--input-field-border);\n} */\n\n.input-field-autocomplete-search .MuiOutlinedInput-notchedOutline {\n    border-style: none;\n}\n\n.input-field-autocomplete-search .MuiInputBase-input{\n    max-height: calc(var(--space-x3) + var(--space-half));\n}\n\n.input-field-autocomplete-search .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] .MuiAutocomplete-input{\n    padding: 0px;\n}\n\n.input-field-autocomplete-search .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] .MuiAutocomplete-input:first-child{\n    padding: 0px;\n}\n\n.input-field-autocomplete-search.MuiFormControl-marginNormal{\n    margin: 0px;\n}\n\n.input-field-autocomplete-search.error .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline { \n    border: var(--input-field-border-error);\n}\n\n.input-field-auto-search {\n    position: relative;\n    margin: var(--space-x3) 0;\n}\n.input-field-autocomplete-search::placeholder {\n    color: var(--disabled-color);\n}\n\n.input-field-autocomplete-search__message {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);\n    color: var(--primary-dark-color);\n    width: fit-content;\n    margin-left: var(--space-x2);\n    margin-top: 4px;\n    margin-left: var(--space);\n    position: absolute;\n    text-align: left;\n}\n.input-field-autocomplete-search__message.error {\n    color: var(--error-color);\n}\n\n.input-field-autocomplete-with-search__list__icon__icon-ball {\n    width: 18px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.input-field-autocomplete-with-search__list__icon {\n    width: 18px;\n    height: 18px;\n}\n\n.input-field-autocomplete-with-search__list__icon__icon-ball .icon-ball {\n    color: var( --white-color );\n    font-size: 12px;\n    border-radius: 50%;\n    padding: 4px;    \n}\n\n.input-field-autocomplete-with-search__list__icon img {\n    width: 18px;\n    border-radius: 50%;\n    height: 18px;\n        \n}\n\n.input-field-autocomplete-with-search__list__icon-team {\n    width: 38px;\n    height: 38px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.input-field-autocomplete-with-search__list__icon-team__icon-ball {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.input-field-autocomplete-with-search__list__icon-team__icon-ball .icon-ball {\n    color: var( --white-color );\n    font-size: 30px;\n    border-radius: 50%;\n    padding: 4px;    \n}\n\n.input-field-autocomplete-with-search__list__icon-team img {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;    \n}\n\n.input-field-autocomplete-with-search__list.MuiListItem-root,\n.input-field-autocomplete-with-search__list-selected.MuiListItem-root  {\n    gap: 10px;\n}\n\n.input-field-autocomplete-with-search__list__country-logo__label {\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    position: absolute;\n    bottom: 52px;\n}\n\n.input-field-autocomplete-with-search__list__country-logo .hubicon-clear_option {\n    font-size: 12px;\n    cursor: pointer;\n}\n\n.input-field-autocomplete-with-search__list-selected__location {\n    display: flex;\n    align-items: center;\n    text-transform: lowercase;\n}\n\n.input-field-autocomplete-with-search__list-selected__location span{\n    text-transform: none;\n}\n\n.input-field-autocomplete-with-search__list-selected__location p::first-letter {\n    text-transform: uppercase;\n}\n\n.input-field-autocomplete-with-search__list-selected .icon-location{\n    margin-right: 4px;\n    font-size: 20px;\n}\n\n.input-field-auto-search .MuiAutocomplete-paper {\n    /* position: fixed; */\n    width: inherit;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
